<template>
    <el-dialog :title="showTitle" :visible.sync="showFlag" :close-on-click-modal="false" v-if="showFlag">
        <el-form
            :inline="true"
            :model="formData"
            class="demo-ruleForm"
            label-width="110px"
            :rules="formRules"
            ref="formData"
            :size="GLOBAL.config.systemSize"
            element-loading-text="数据处理中...请稍等..."
            v-loading="loading">
            <!--区划-->
            <el-form-item label="所属区划：" prop="ssqh" style="margin-top: 10px">
                <cascader :set-props="setProps"
                        :set-size="GLOBAL.config.systemSize" maxlength="64"
                        ref="myArea">
                </cascader>
            </el-form-item>
            <el-form-item label="改厕户姓名：" prop="hz" style="margin-top: 10px">
                <el-input v-model="formData.hz" placeholder="改厕户姓名" maxlength="64" :disabled="editFlag"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="hzsjh" style="margin-top: 10px">
                <el-input v-model="formData.hzsjh" placeholder="手机号" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="hzsfz" style="margin-top: 10px">
                <el-input v-model="formData.hzsfz" placeholder="身份证号" maxlength="64" :disabled="editFlag"></el-input>
            </el-form-item>
            <el-form-item label="改厕编号：" prop="gcbh" style="margin-top: 10px">
                <!-- <el-input v-model="formData.gcbh" placeholder="改厕编号" maxlength="11" oninput="value=value.replace(/[^\d]/g,'')"></el-input> -->
                <el-input v-model="formData.gcbh" placeholder="改厕编号" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="改厕日期：" prop="gcrq" style="margin-top: 10px">
                <el-date-picker  type="year"   value-format="yyyy" v-model="formData.gcrq" style="width:100%;">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="详细地址：" prop="wzdw" style="margin-top: 10px">
                <el-input v-model="formData.wzdw" placeholder="详细地址" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="改厕类型：" prop="gczt" style="margin-top: 10px">
                <el-select v-model="formData.gczt" placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;" @change="change1()">
                    <el-option
                    v-for="item in dictionary.gczts"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="改厕状态：" prop="gclx" style="margin-top: 10px">
                <el-select v-model="formData.gclx" placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;" @change="change2()">
                    <el-option
                    v-for="item in dictionary.gclxs"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="清掏方式：" prop="qtfs" style="margin-top: 10px">
                <el-select v-model="formData.qtfs" placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;" @change="change3()">
                    <el-option
                    v-for="item in dictionary.qtfss"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上传图片：" ref="imgRule" style="margin-top: 10px" prop="imgListShow">
                <el-upload
                    :action="uploadUrl"
                    list-type="picture-card"
                    accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PNG,.BMP"
                    :before-upload="beforeUpload"
                    :on-success="uploadSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove" :limit="3" style="text-align: left;" :file-list="imgListShow">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" z-index="1000">
                    <img width="70%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
        </el-form>
        <el-row class="margin-top-10">
            <el-button @click="closeDialog" style="margin: 0 10px;" :size="GLOBAL.config.systemSize">关闭</el-button>
            <el-button type="primary" @click="saveOrUpdateForm('formData')" style="margin: 0 20px;"
                        :size="GLOBAL.config.systemSize">保存
            </el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import cascader from '../../components/Cascader'
export default {
    name: "GCArchivesInfoEditDialog",

    components: {
        cascader,
    },

    props: {
      refresh: {
        type: Function
      },
    },

    data() {
        return {
            title: '',
            showFlag: false,
            showTitle: '',
            loading: false,
            type: '',
            formData: {
                uuid: '',
                hz: '',
                ssqh: '',
                hzsjh: '',
                wzdw: '',
                hzsfz: '',
                gcbh: '',
                gcrq: '',
                qtfs: '',
                gclx: '',
                gczt: '',
                imgListShow: []
            },
            formRules: {
                ssqh: [
                    {required: true, message: '所属区划不能为空', trigger: 'blur'}
                ],
                hz: [
                    {required: true, message: '改厕户姓名不能为空', trigger: 'blur'}
                ],
                hzsjh: [
                    // {required: true, message: '手机号不能为空', trigger: 'blur'},
                    {pattern: /^1[3456789]\d{9}$/, message : '请输入正确的手机号', trigger: 'blur'}
                ],
                wzdw: [
                    {required: true, message: '详细地址不能为空', trigger: 'blur'}
                ],
                hzsfz: [
                    {required: true, message: '身份证号不能为空', trigger: 'blur'},
                    {pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/, message : '请输入正确的身份证号', trigger: 'blur'}
                ],
                gcbh:[
                    {required: true, message: '改厕编号不能为空', trigger: 'blur'},
                ],
                gcrq: [
                    {required: true, message: '改厕日期不能为空', trigger: 'blur'},
                ],
                gczt: [
                    {required: true, message: '改厕状态不能为空', trigger: 'blur'},
                ],
                gclx: [
                    {required: true, message: '改厕类型不能为空', trigger: 'blur'},
                ],
                qtfs: [
                    {required: true, message: '清掏方式不能为空', trigger: 'blur'},
                ],
                imgListShow: [
                    {required: true, message: '请至少上传一张图片'},
                ]
            },
            //所属区域
            setProps: {
                multiple: false, // 单选
                checkStrictly: true, // 父节点取消选中关联
                value: 'code',
                label: 'name',
                children: 'children',
                leaf: 'leaf'
            },
            dialogImageUrl: '',
            dialogVisible: false,
            uploadUrl: this.CONFIG.urls.root + '/upload?ssQh=000000000001',
            imgList: [],
            imgListShow: [],
            editFlag: false,
            dictionary: {
                // 改厕状态
                gczts: JSON.parse(unescape(localStorage.getItem("GC_TYPE"))),
                // 改厕类型
                gclxs: JSON.parse(unescape(localStorage.getItem("GC_LX"))),
                // 清掏方式
                qtfss: JSON.parse(unescape(localStorage.getItem("ZX_QT")))
            },
            imgSsqh: '' // 图片上传所属区划代码
        }
    },
    methods: {
        change1(){
            this.$forceUpdate()
        },
        change2(){
            this.$forceUpdate()
        },
        change3(){
            this.$forceUpdate()
        },
        // 重置formData
        resetFormData () {
          this.formData = {
            uuid: '',
            hz: '',
            ssqh: '',
            hzsjh: '',
            wzdw: '',
            hzsfz: '',
            gcbh: '',
            gcrq: '',
            qtfs: '',
            gclx: '',
            gczt: '',
            imgListShow: []
          }
        },
        beforeUpload (file) {
            let myAreaCode = this.$refs.myArea.sendToParent('value')
            let flag = true
            if (!myAreaCode) {
                this.$message.warning('请选择所属区划后再上传照片！')
                flag = false
            }
            this.imgSsqh = myAreaCode
            if (file.type.indexOf('image') === -1) {
                flag = false
                this.$message.error('请选择图片上传！')
            }
            return flag
        },
        uploadSuccess (response, file, fileList) {
            if (response && response.code == '200') {
                this.imgList.push(response.obj);
                this.imgListShow.push({url: response.obj.url, status: file.status, uid: file.uid, uuid: '', glUuid: response.obj.glUuid});
                this.formData.imgListShow = this.imgListShow
            } else {
                this.$message.warning('上传失败');
            }
        },
        handleRemove(file, fileList) {
            if (file.uuid) {
                this.imgList = this.imgList.filter(item => item.uuid != file.uuid)
                this.imgListShow = this.imgListShow.filter(item => item.uuid != file.uuid)
                this.formData.imgListShow = this.imgListShow
            } else {
                this.imgList = this.imgList.filter(item => item.glUuid != file.glUuid)
                this.imgListShow = this.imgListShow.filter(item => item.glUuid != file.glUuid)
                this.formData.imgListShow = this.imgListShow
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        getBaseData() {
            this.loading = true;
            let _this = this;
            let param = {
                info: _this.formData.uuid,
                baseService: 'TGcGcdaServiceImpl',
                type: _this.GLOBAL.config.handleType.getInfoById,
            }
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // debugger
                        // _this.formData = resultData.obj;
                        _this.formData.hz = resultData.obj.TGcGcda.hz;
                        _this.formData.ssqh = resultData.obj.TGcGcda.ssqh;
                        _this.formData.hzsjh = resultData.obj.TGcGcda.hzsjh;
                        _this.formData.wzdw = resultData.obj.TGcGcda.wzdw;
                        _this.formData.hzsfz = resultData.obj.TGcGcda.hzsfz;
                        _this.formData.gcbh = resultData.obj.TGcGcda.gcbh;
                        _this.formData.gcrq = resultData.obj.TGcGcda.gcrq;
                        _this.formData.gczt = resultData.obj.TGcGcda.gczt;
                        _this.formData.gclx = resultData.obj.TGcGcda.gclx;
                        _this.formData.qtfs = resultData.obj.TGcGcda.qtfs;
                        _this.imgList = resultData.obj.TGcFj;
                        for (const key in _this.imgList) {
                            _this.imgListShow.push({url: resultData.obj.TGcFj[key].url, uuid: resultData.obj.TGcFj[key].uuid, glUuid: resultData.obj.TGcFj[key].glUuid});
                        }
                        _this.formData.imgListShow = _this.imgListShow;
                    } else {

                    }
                }
            )
        },
        open(type, rowData) {
            let _this = this;
            let title = '';
            _this.type = type;
            _this.imgList = [];
            _this.imgListShow = [];
            if (type == 'edit') {
                _this.editFlag = true;
                title = '改厕档案编辑';
                _this.formData.uuid = rowData.uuid;
                _this.getBaseData();
            } else if (type == 'add') {
                _this.editFlag = false;
                title = '改厕档案新增';
                _this.resetFormData()
                _this.imgList = []
            }
            _this.showFlag = true;
            setTimeout(function () {
              _this.$refs.myArea.init(_this.formData.ssqh)
            }, 500)
            _this.showTitle = title;
        },
        closeDialog() {
            this.imgList = [];
            this.imgListShow = [];
            this.resetFormData();
            this.$refs['formData'].resetFields();
            this.showFlag = false;
        },
        saveOrUpdateForm(formName) {
            let _this = this;
            let myAreaCode = this.$refs.myArea.sendToParent('value')
            if (!myAreaCode) {
                this.$message.warning('请选择所属区划～')
                return
            }
            let codeStr = myAreaCode.substring(10, 12)
            if (codeStr === '00') {
                this.$message.warning('所属区划请选择至村居～')
                return
            }
            if (!this.formData.gczt) {
                this.$message.warning('请选择改厕状态～')
                return
            }
            if (!this.formData.gclx) {
                this.$message.warning('请选择改厕类型～')
                return
            }
            if (!this.formData.qtfs) {
                this.$message.warning('请选择清掏方式～')
                return
            }
            if (this.imgList.length == 0) {
                this.$message.warning("请至少上传一张图片");
                return;
            }
            let param = {};
            // param = _this.formData;
            // param.ssqh = _this.$refs.myArea.sendToParent('value');
            param.baseService = 'TGcGcdaServiceImpl';
            param.tGcGcda = _this.formData;
            param.tGcGcda.ssqh = _this.$refs.myArea.sendToParent('value');
            param.tGcFj = _this.imgList;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let method = "";
                    if (_this.formData.uuid) {
                        method = 'updateAlls';
                    } else {
                        // method = _this.GLOBAL.config.handleType.add;
                        method = 'addAlls';
                    }
                    delete param.tGcGcda.imgListShow
                    _this.loading = true
                    _this.FUNCTIONS.systemFunction.interactiveData(
                        _this,
                        _this.GLOBAL.config.businessFlag.zxUser,
                        method,
                        param,
                        null,
                        resultData => {
                            _this.loading = false
                            if (resultData.code == '200') {
                                _this.$message.success('保存成功～')
                                _this.closeDialog()
                                _this.$props.refresh && _this.$props.refresh('init')
                            } else {
                                _this.$message.warning(resultData.errorMsg)
                            }
                        },
                        () => {
                            _this.loading = false
                        }
                    )
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
    .el-form-item /deep/ .el-upload--picture-card {
        width: 100px;
        height: 100px;
    }
    .el-form-item /deep/ .el-upload {
        width: 100px;
        height: 100px;
        line-height: 100px;
    }
    .el-form-item /deep/ .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }
    .el-form-item /deep/ .el-upload-list--picture-card .el-upload-list__item {
        width: 100px;
        height: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/view/GCArchivesInfo/GCArchivesInfoEditDialog.vue